import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

// Fetches the RCA reason options for user-level coupon creation (BE is the source of truth).
export const useUserLevelCouponReasonsAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [reasons, setReasons] = useState<string[]>([]);

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(COUPON_SERVICE_APIS?.USER_LEVEL_COUPON_REASONS?.baseURL, {
          headers: { Authorization: `${accessToken}`, "Content-Type": "application/json" },
        })
        .then((res: AxiosResponse<{ status: boolean; data: string[] }>) => {
          setReasons(res.data?.status ? res.data?.data ?? [] : []);
        })
        .catch((e: AxiosError) => {
          setReasons([]);
          sendCurl(e.config["curlCommand"]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, []);

  return { execute, reasons };
};
